/*
 *                     NOTICE
 *            COPYRIGHT 2019 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

export class NonAbInitioResponseError extends Error {
  constructor(errorMsg) {
    // Typescript compiler will accept super(errorMsg) just fine and emit the corresponding javascript
    // However, the browser js runtime can still refuse to allow a builtin to be extended, and thus the msgArg is 'lost'
    // super(errorMsg); // does NOT work in Chrome (and perhaps other browsers as well)

    // Workaround: See https://github.com/Microsoft/TypeScript/issues/1168#issuecomment-112955503
    //   specifically comment by 'unional' on Jun 2, 2015
    super();
    this.message = errorMsg;
  }
}
//# sourceMappingURL=NonAbInitioResponseError.js.map
